<div class="d-flex">
    <ol class="breadcrumb">
        <li *ngFor="let route of routes; index as i">
            <a role="button" class="d-flex align-items-center text-decoration-none" (click)="onNavClick(i)">
                <ng-container *ngIf="route.icon">
                    <mat-icon class="d-flex icon align-items-center">{{route.icon}}</mat-icon>
                </ng-container>
                <span>{{route.label | translate}}</span>
            </a>
        </li>
    </ol>
</div>